import React from 'react';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';
import { SvgGroupCenter } from 'apps/sigma2-ui/src/components/svg/SvgGroupCenter';
import { LevelDefinitionIconProps } from 'apps/sigma2-ui/src/components/level-definition-icon-props';

export const BlueRoundedTriangleGroup: React.FC<LevelDefinitionIconProps> = (
  props,
) => {
  const fillColor = toSvgColor('#34D2DC', props);
  return (
    <g fill="none" {...(props.group ?? {})}>
      <SvgGroupCenter {...props} baseWidth={12} baseHeight={12}>
        <path
          d="M1.30665 8.7119L5.1221 1.7169C5.50112 1.02203 6.49888 1.02203 6.87789 1.7169L10.6934 8.7119C11.0568 9.37828 10.5745 10.1908 9.81546 10.1908H2.18454C1.42548 10.1908 0.943169 9.37828 1.30665 8.7119Z"
          fill={fillColor}
        />
      </SvgGroupCenter>
    </g>
  );
};
export const BlueRoundedTriangleSvg: React.FC<LevelDefinitionIconProps> = (
  props,
) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <BlueRoundedTriangleGroup {...props} />
    </svg>
  );
};
